import MersenneTwister from 'mersenne-twister'

const Parse = function(screens, blocks, blocksOrder, seedNumber) {
    const steps = [];
    const shuffledBlocks = {}
    const generator = new MersenneTwister(seedNumber / 1000);
    console.log( generator );
    blocksOrder.map(b=>{
        const block = blocks.find((_block)=>_block._id === b);

        if( block.randomize === undefined || block.randomize === 0) { //0: no randomization needed
            shuffledBlocks[b] = block.screenKeys 
        } else {
            let newScreenKeys = shuffle(block.screenKeys, generator);
            if(block.randomize === -1) { //-1: return all screens, shuffled in new order.
                shuffledBlocks[b] = newScreenKeys 
            } else {
                newScreenKeys = newScreenKeys.slice(0,block.randomize);
                shuffledBlocks[b] = newScreenKeys; // return the first n screens, according to randomize value
            }
        }
    });

    for (const b in shuffledBlocks) {
        
        shuffledBlocks[b].forEach(s=>{
            const screen = screens.find((_screen)=>_screen._id === s);
            // console.log(screen);
            if(screen.followTo === "by_ans"){
                screen.followingScreen = "by_ans";
                //Reconfiguring "followingBlock" parameter of answers to "followingScreen"
                screen[screen.type].answers = screen[screen.type].answers.map(a=>{
                    
                    if( !a.followTo || a.followTo == "next_screen" || shuffledBlocks[a.followTo] === undefined ) {
                        // following screen is undefined. follow to next screen.

                        return {
                            ...a,
                            followingScreen: "next_screen" 
                        }
                    } 

                    const targetScreenId = shuffledBlocks[a.followTo][0]; //pick the first screen of the following block
                    const targetQkey = screens.find((_screen)=>_screen._id === targetScreenId).qKey; //SekerApp navigation works with the screen key
                    const newAns = {
                        ...a,
                        followingScreen: targetQkey 
                    }
                    
                    return newAns
                })
                
            } else if(screen.followTo !== "next_in_order" && shuffledBlocks[screen.followTo]){ 
                //Reconfiguring "followTo" parameter from block to screen:
                const targetScreenId = shuffledBlocks[screen.followTo][0]; //pick the first screen of the following block
                const targetQkey = screens.find((_screen)=>_screen._id === targetScreenId).qKey; //SekerApp navigation works with the screen key
                screen.followingScreen = targetQkey; 
            }
            
            steps.push(screen);
        })
    };

    return steps;
}

const shuffle = function(list, generator) {
    let currentIndex = list.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(generator.random() * currentIndex);
      currentIndex -= 1;
  
      temporaryValue = list[currentIndex];
      list[currentIndex] = list[randomIndex];
      list[randomIndex] = temporaryValue;
    }

    return list;
}

export default Parse;


// WEBPACK FOOTER //
// ./src/Utils/BlocksToStepsParser.js